import React, { useState, useCallback } from 'react';

const BottomSheetContext = React.createContext();

export const BottomSheetProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentService, setCurrentService] = useState(null);

  const closeBottomSheet = useCallback(() => {
  setIsOpen(false);
  setCurrentService(null);
}, []);

const openBottomSheet = useCallback((service) => {
  setCurrentService({ ...service, isSelected: true });
  setIsOpen(true);
}, []);

  const updateNavigationZIndex = useCallback((isBottomSheetOpen) => {
    const navigationContainer = document.querySelector('.navigation-container');
    if (navigationContainer) {
      navigationContainer.style.zIndex = isBottomSheetOpen ? '0' : '1000';
    }
  }, []);

  return (
    <BottomSheetContext.Provider value={{ 
      isOpen, 
      setIsOpen, 
      currentService, 
      setCurrentService, 
      closeBottomSheet,
      openBottomSheet,
      updateNavigationZIndex,
      pill: '',
    }}>
      {children}
    </BottomSheetContext.Provider>
  );
};

export const useBottomSheet = () => React.useContext(BottomSheetContext);

export default BottomSheetProvider;
